export enum Achievement {
  Success = 'Atteint',
  Partial = 'Partiellement atteint',
  Fail = 'Non atteint',
}

export const labelsByAchievement: Map<Achievement, string> = new Map<Achievement, string>(
  Object.keys(Achievement).map((x: string) => [x, Achievement[x]] as [Achievement, string]),
);
